import React, { useEffect, useState } from 'react';
import { callApi } from '../../api/call';
import DeluxeEmbeddedPaymentForm from '../embedded/DeluxeEmbeddedPaymentForm';
import { getDeluxeEnvironment } from '../../website/services/payment/deluxeEnvironment';
import '../embedded/DeluxeEmbeddedPaymentForm.css';

const DeluxeVaultSetup = ({ onVaultReady, disabled = false, environment }) => {
  const [config, setConfig] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    callApi('/api/payments/deluxe/hosted-form', {
      scope: 'platform',
      mode: 'vault',
      environment: environment || getDeluxeEnvironment(),
    }, { auth: false })
      .then((res) => {
        if (!cancelled) setConfig(res.data);
      })
      .catch((err) => {
        if (!cancelled) setError(err?.message || 'Deluxe is not configured in admin App Settings');
      });
    return () => {
      cancelled = true;
    };
  }, [environment]);

  if (error) {
    return <div className="deluxe-embedded__error" role="alert">{error}</div>;
  }
  if (!config) {
    return <p className="deluxe-embedded__status">Loading Deluxe card form…</p>;
  }

  return (
    <DeluxeEmbeddedPaymentForm
      jwt={config.jwt}
      scriptUrl={config.scriptUrl}
      mode="vault"
      disabled={disabled}
      onSuccess={onVaultReady}
      onError={(err) => setError(err?.message || 'Card form failed')}
    />
  );
};

export default DeluxeVaultSetup;
